import React from "react";
import { connect } from "react-redux";
import CommonCard from "./ExistCommonCard"
import { getKeywordLineItemsList, deleteKeywordLineItemsList } from "../Actions/ExistKeywordManagementAPI";
import { confirmAlert } from 'react-confirm-alert';

let user = JSON.parse(localStorage.getItem("currentUser"));

class KeywordManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: '',
        PageNumber: 1,
        PageSize: 25
      },
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchData = this.SearchData.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    dispatch({ type: 'SubBannerTitle', data: "Existing Keyword Management" });
    dispatch(getKeywordLineItemsList(this.state.searchData));
  }

  handleInputChange(e) {
    this.state.searchData.Name = e.target.value;
    if (e.target.value === "") {
      this.props.dispatch(getKeywordLineItemsList(this.state.searchData));
    }
    this.setState({});
  }

  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(getKeywordLineItemsList(this.state.searchData));
  }

  DeletePopup(item) {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteKeywordData(item)
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }
  DeleteKeywordData(item) {
    let listitem = {
      keywordId:parseInt(item.lineItemId),
      modifiedBy: user.email,
    }
    this.props.dispatch(deleteKeywordLineItemsList(listitem));
    this.state.searchData.Name = "";
    this.setState({});
  }

  ClearInput = () => {
    this.state.searchData.Name = "";
    this.props.dispatch(getKeywordLineItemsList(this.state.searchData));
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }

  render() {
    const { showSidePane, KeywordLineItemsList } = this.props;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
          onClick={() => this.hideSidePanel()} > &larr; Back
            </button>
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                         Existing Keyword Management
                        </h5>
                      
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className={showSidePane ? "col-lg-6 " : "col-lg-6 "}>
                          <label className="form-label">Exist Keyword</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="keyword"
                            placeholder="Keyword"
                            value={this.state.searchData.Name}
                            onChange={e => this.handleInputChange(e)}
                          ></input>
                        </div>

                        <div className={showSidePane ? "col-lg-6" : "col-lg-6"}>
                          <label className="mt-4"></label><br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchData(1)}
                            >
                              {" "}
                              Search{" "}
                            </button>

                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              Clear{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {KeywordLineItemsList ? (
                <CommonCard
                  arraylist={KeywordLineItemsList.data}
                  pageSize={KeywordLineItemsList.pagination.pageSize}
                  currentPage={KeywordLineItemsList.pagination.currentPage}
                  totalRecords={KeywordLineItemsList.pagination.totalcount ? KeywordLineItemsList.pagination.totalcount : 0}
                  DeleteKeyword={item => this.DeletePopup(item)}
                  setUpdatedState={(value) => this.SearchData(value)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }


}



function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    KeywordLineItemsList: state.MasterScreenReducer.KeywordLineItemsList,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeywordManagement);
